module.exports = __webpack_public_path__ + "img/cookie-policy.f9f81161.png";